import React, { FC } from 'react';
import { CustomColumn } from '../../../../../types/components/tables/tableTypes';
import GridItem from '../../../../layout/GridComponents/GridItem';
import CustomTable from '../../../../tables/CustomTable';
import type { MancoExposurePayload } from '../../../../../api/rs-hg/manco';

interface MancoAssetGrossExposureProps {
  data: MancoExposurePayload;
  isFetching: boolean;
}

interface MancoAssetGrossExposureData {
  data: string;
  value: string;
}

export function buildMancoAssetGrossExposure(data: MancoExposurePayload) {
  if (!data) return [];
  if (!('security_exposure' in data)) return [];
  if (!('derivative_exposure' in data)) return [];
  if (!('manco_nav' in data)) return [];

  const { security_exposure, derivative_exposure, manco_nav } = data;

  const items = [
    {
      data: 'Cash Securities',
      value: `${((security_exposure / manco_nav) * 100).toFixed(2)}%`,
    },
    {
      data: 'Derivative Securities',
      value: `${((derivative_exposure / manco_nav) * 100).toFixed(2)}%`,
    },
  ];
  return items;
}

const tableColumns: CustomColumn<MancoAssetGrossExposureData>[] = [
  {
    title: 'Data',
    field: 'data',
    cellStyle: {
      textAlign: 'left',
    },
    headerStyle: {
      textAlign: 'left',
    },
  },
  {
    title: 'Field',
    field: 'value',
    cellStyle: {
      textAlign: 'right',
      // borderRight: theme.borders!.light,
    },
    headerStyle: {
      textAlign: 'left',
    },
  },
];

const MancoAssetGrossExposure: FC<MancoAssetGrossExposureProps> = ({
  data,
  isFetching,
}) => {
  const renderedData = buildMancoAssetGrossExposure(data);

  return (
    <GridItem card xs={12} cardStyle={{ height: '100%' }}>
      <CustomTable<MancoAssetGrossExposureData>
        multipleTablePdfParameters={{
          specifiedWidth: 4,
          tablesInRow: 3,
        }}
        id={'manco_asset_class_gross_exposure'}
        title="Asset Type Gross Exposure"
        showToolbar={true}
        columns={tableColumns}
        toolbarComponents={{
          toolbarTitle: 'Asset Type Gross Exposure',
        }}
        data={renderedData}
        loading={isFetching}
        options={{
          paging: false,
          search: false,
          header: false,
          exportButton: false,
        }}
      />
    </GridItem>
  );
};

export default MancoAssetGrossExposure;
